export var Text = {
  baseStyle: {
    letterSpacing: 'normal'
  },
  variants: {
    lead: {
      letterSpacing: 'normal'
    },
    body: {
      letterSpacing: 'normal'
    }
  }
};